import React from 'react';

const foot = require('./images/ht_footer.png');

export default function Footer() {

    return(

        <div>
            <img src={foot} width='100%' alt='sustainable coaster design'/>
            
        </div>
    )

}